export const ConsumerDobFormUat = {
  field: 'workflow.consumerDob.field',
  submitButton: 'workflow.consumerDob.submitButton',
}
